import React, { useCallback, useState } from 'react';
import LinkPreviewModal from './link-preview-modal';

interface ItemContentProps {
    id: number;
    title: string;
    type: string;
    description: string;
    link: string;
    linkDescription: string;
    tags: string[];
    date: string;
    color: string;
}

const ItemContent = ({ title, type, description, link, linkDescription, tags, date, color }: ItemContentProps) => {
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);

    const handleClose = useCallback(() => setIsPreviewOpen(false), []);

    const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        const isModified = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0;
        if (isModified) return;
        e.preventDefault();
        setIsPreviewOpen(true);
    };

    return (
        <div className={`item-content ${color}`}>
            <div className={`title ${color}`}>
                <h2>{title}</h2>
                <span className="item-type">{type}</span>
            </div>
            <div className={`description ${color}`}>
                {description}
                <div className={`link ${color}`}>
                    <a href={link} target="_blank" rel="noopener noreferrer" className={color} onClick={handleLinkClick}>{linkDescription}</a>
                </div>
            </div>
            <div className={`footer ${color}`}>
                <div className="tags">{tags.map((desc: string) => `#${desc} `)}</div>
                <div className="date">{date}</div>
            </div>
            {isPreviewOpen && (
                <LinkPreviewModal title={title || linkDescription} url={link} onClose={handleClose} />
            )}
        </div>
    );
};

export default ItemContent;
